import config from '../configs/config';
import BindoService from './base/bindoService';

class otherPaymentInstrumentService extends BindoService {

  getAll(storeId) {
    let path = `v2/stores/${storeId}/other_payment_instruments`;
    return this.get(path, null, config.goGatewayApi);
  }

  updateAll(storeId, data) {
    let path = `v2/stores/${storeId}/other_payment_instruments/update_all`;
    return this.post(path, data, config.goGatewayApi);
  }

  modifyAll(storeId, data) {
    let path = `v2/stores/${storeId}/other_payment_instruments/modify_all`;
    return this.post(path, data, config.goGatewayApi);
  }

  getAllWithDefalut(storeId) {
    let path = `v2/stores/${storeId}/other_payment_instruments`
    return this.get(path, {all: 1}, config.goGatewayApi);
  }

  modifyAllWithDefault(storeId, data){
    let path = `v2/stores/${storeId}/other_payment_instruments/modify_all?all=1`;
    return this.post(path, data, config.goGatewayApi);
  }
}

export default new otherPaymentInstrumentService();



/** WEBPACK FOOTER **
 ** ./client/services/otherPaymentInstrumentService.js
 **/